import { datadogRum } from '@datadog/browser-rum';

export type TrackCtaClickActionParams = {
  entityName: string;
  shouldFireShoppingFinished: boolean;
  shoppingFinishedId: string;
  ctaType: string;
};

export function isPaidBankingRoundupPath(pathname: string): boolean {
  return pathname.startsWith('/banking/m/');
}

/**
 * We are temporarily tracking the CTA click action for banking entities.
 * This is a temporary monitoring solution and will be removed once we have a better understanding on
 * our Bot traffic.
 */
export function trackCtaClickAction({
  entityName,
  shouldFireShoppingFinished,
  shoppingFinishedId,
  ctaType,
}: TrackCtaClickActionParams) {
  datadogRum.addAction('CTA Button Click', {
    entityName,
    shouldFireShoppingFinished,
    shoppingFinishedId,
    referrer: document.referrer,
    ctaType,
  });
}
